import styles from "../styles/profile.module.scss";
import Button from "../../../components/shared/Button/Button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { useDispatch } from "react-redux";
import { setOpenModal } from "../../../store/slices/modals.slice";
import { useAppSelector } from "../../../store/store";
import useWindowSize from "../../../hooks/useWindowSize";

interface IProps {
  id: number;
  amount: string;
  total: number;
  price: number;
  discount: string;
  priceUpToDate: boolean;
  subscribe: (id: number) => void;
  isActiveFlag: boolean;
}
const SubscriptionCard = ({ id, amount, total, price, discount, priceUpToDate, subscribe, isActiveFlag }: IProps) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const userData = useAppSelector((state: any) => state.auth.userData);

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";
  const { windowSize } = useWindowSize();
  const isMobile = windowSize === "mobile";

  return (
    <div className={styles.subscriptionCardWrapper}>
      <div className={styles.cardBlock}>
        <div className={styles.cardHolder}>
          <div className={styles.cartAmountWrapper}>
            {discount && (
              <div dir={dirData} className={styles.discount}>
                {t("shortDiscount")} {discount}
              </div>
            )}
            <div className={styles.amount}>{amount}</div>
          </div>
          <div
            className={`${styles.total} ${discount ? styles.totalWithDiscount : ""}`}
          >
            {priceUpToDate ? total : "..."}
            {id === 2 ? t("perYear") : t("perMth")}
          </div>

          {isMobile && (
            <Link to={ROUTES.DISCOUNT} className={styles.cardLink}>
              {t("readMoreSub")}
            </Link>
          )}
        </div>
        <div className={styles.cardRightContent}>
          <div className={`${styles.priceWrapper} ${isActiveFlag && styles.priceWrapperActive}`}>
            {!isActiveFlag ? (
              <div className={styles.price}>
                {priceUpToDate ? price : "..."}
                <span> $</span>
              </div>
            ) : (
              <div className={styles.priceActive}>{t("active")}</div>
            )}

            {!isActiveFlag && !isMobile && (
              <div className={styles.buttonsWrapper}>
                <Button
                  className={styles.connectButton}
                  title={t("subscribe")}
                  submit={() => {
                    if (id !== 0 && userData.is_subscribed && userData.product_id !== id) {
                      dispatch(setOpenModal("changeSub"));
                    }
                    subscribe(id);
                  }}
                />
              </div>
            )}

            {!isActiveFlag && isMobile && (
              <div className={styles.buttonsWrapper}>
                <Button
                  className={styles.connectButton}
                  title={t("subscribe")}
                  submit={() => {
                    if (id !== 0 && userData.is_subscribed && userData.product_id !== id) {
                      dispatch(setOpenModal("changeSub"));
                    }
                    subscribe(id);
                  }}
                />
              </div>
            )}
          </div>
          {!isActiveFlag && isMobile && (
            <div className={styles.price}>
              {priceUpToDate ? price : "..."}
              <span> $</span>
            </div>
          )}
        </div>
      </div>
      {!isMobile && (
        <Link to={ROUTES.DISCOUNT} className={styles.cardLink}>
          {t("readMoreSub")}
        </Link>
      )}
    </div>
  );
};

export default SubscriptionCard;
